import { Construction, RefreshCw } from 'lucide-react';

const ClosedBanner = () => {
  return (
    <div className="fixed inset-0 z-[9999] bg-[#181B1F] flex items-center justify-center">
      <div className="text-center px-6 max-w-2xl">
        {/* Logo */}
        <img 
          src="/logo.png" 
          alt="Geneva Rental" 
          className="h-16 mx-auto mb-8 opacity-80"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
        
        {/* Icon */}
        <div className="w-24 h-24 mx-auto mb-8 rounded-full bg-primary/10 flex items-center justify-center">
          <RefreshCw className="w-12 h-12 text-primary" />
        </div>
        
        {/* Message FR */}
        <h1 className="font-serif text-4xl md:text-5xl text-white mb-4">
          Fermé temporairement
        </h1>
        <p className="text-xl text-white/70 mb-8">
          Renouvellement de flotte en cours
        </p>
        
        {/* Divider */}
        <div className="w-24 h-px bg-primary/50 mx-auto mb-8"></div>
        
        {/* Message EN */}
        <h2 className="font-serif text-2xl md:text-3xl text-white/80 mb-3">
          Temporarily Closed
        </h2>
        <p className="text-lg text-white/50 mb-12">
          Fleet renewal in progress
        </p>
        
        {/* Contact */}
        <div className="bg-white/5 rounded-lg p-6 border border-white/10">
          <p className="text-white/60 text-sm mb-2">Pour toute question / For any inquiries</p>
          <a 
            href="mailto:info@genevarental.ch" 
            className="text-primary hover:text-primary/80 transition-colors text-lg"
          >
            info@genevarental.ch
          </a>
        </div>
        
        {/* Footer */}
        <p className="text-white/30 text-sm mt-12">
          © 2024 Geneva Rental. Tous droits réservés.
        </p>
      </div>
    </div>
  );
};

export default ClosedBanner;
